import { inject, Injectable } from '@angular/core';
import { Notification } from '@layout/notifications/models/notification.interface';
import { NotificationSource } from '@layout/notifications/models/notification-source.enum';
import { NotificationType } from '@layout/notifications/models/notification-type.enum';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationTemplateService {
  private readonly translateService = inject(TranslateService);

  getNotificationTitle(notification: Notification): Observable<string> {
    if (notification.source === NotificationSource.Zendesk) {
      const labelKey = 'notifications.zendesk-notification-title';

      switch (notification.type) {
        case NotificationType.ZendeskTicketWasChanged: {
          return this.translateService.get(labelKey, { ticketId: notification.zendeskTicketWasChanged?.ticketId });
        }

        case NotificationType.ZendeskTicketFieldWasChanged: {
          return this.translateService.get(labelKey, { ticketId: notification.zendeskTicketFieldWasChanged?.ticketId });
        }
      }
    }

    return this.translateService.get('notifications.default-notification-title');
  }

  getNotificationContent(notification: Notification): Observable<string> {
    if (notification.source === NotificationSource.Zendesk) {
      switch (notification.type) {
        case NotificationType.ZendeskTicketWasChanged: {
          return this.translateService.get(notification.zendeskTicketWasChanged?.subject ?? '');
        }

        case NotificationType.ZendeskTicketFieldWasChanged: {
          return this.translateService.get(notification.zendeskTicketFieldWasChanged?.subject ?? '');
        }
      }
    }

    return this.translateService.get('notifications.default-notification-body');
  }
}
